export const BADGES_ALIGNMENT_LEFT = "left";
export const BADGES_ALIGNMENT_CENTER = "center";
export const BADGES_ALIGNMENT_RIGHT = "right";
export const BADGES_ALIGNMENT_SPACE_AROUND = "space-around";
export const BADGES_ALIGNMENT_SPACE_BETWEEN = "space-between";
export const BADGES_ALIGNMENT_SPACE_EVENLY = "space-evenly";

export const BADGES_ALIGNMENT = [
  BADGES_ALIGNMENT_LEFT,
  BADGES_ALIGNMENT_CENTER,
  BADGES_ALIGNMENT_RIGHT,
  BADGES_ALIGNMENT_SPACE_AROUND,
  BADGES_ALIGNMENT_SPACE_BETWEEN,
  BADGES_ALIGNMENT_SPACE_EVENLY
] as const;

export const BADGES_MOBILE_LAYOUT_3COL = "3col";
export const BADGES_MOBILE_LAYOUT_2COL = "2col";

export const BADGES_MOBILE_LAYOUT = [BADGES_MOBILE_LAYOUT_3COL, BADGES_MOBILE_LAYOUT_2COL] as const;
